<template>
  <v-row
    v-if="!isLoading"
    justify="center"
    align="center"
  >
    <v-icon
      :color="setColor"
    >
      mdi-{{ setCheckIcon }}
    </v-icon>
    <span
      :style="`color:${setColor};`"
    >
      {{ label }}
    </span>
  </v-row>
  <v-row v-else>
    <skeleton
      width="15"
      height="15"
      radius="50"
      class="mr-1"
    />
    <skeleton
      width="130"
      height="15"
    />
  </v-row>
</template>

<script>
export default {
  name: 'CheckComponent',
  props: {
    value: {
      type: Boolean,
    },
    label: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    setCheckIcon() {
      return this.value ? 'check-circle' : 'close-circle';
    },
    setColor() {
      return this.value ? '#2ABD49' : '#a91314';
    },
    isLoading() {
      return this.loading;
    },
  },
};
</script>

<style>

</style>
